import { Component, OnInit } from '@angular/core';
import {
  GamesGroupService,
  GroupType,
  IGroupSummary,
  PopulationQuery,
  ProgressStatus,
  SortFn,
  TriviaGroupSummary,
} from '@fgb/core';
import { filterBy, sortBy } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

enum GAME_TAB {
  LIVE_UPCOMING = 0,
  RESULTS = 1,
}

@Component({
  selector: 'fgb-quiz-page',
  templateUrl: './quiz-page.component.html',
  styleUrl: './quiz-page.component.scss',
})
export class QuizPageComponent implements OnInit {
  gamesGroup$: Observable<TriviaGroupSummary[]>;
  groupType = GroupType.Trivia;
  currentTab = GAME_TAB.LIVE_UPCOMING;
  filters: any = [];
  sort: SortFn[] = [];
  gameTab = GAME_TAB;

  populations = Populations;
  isCorporate: boolean;

  constructor(
    private gamesGroupService: GamesGroupService,
    private populationQuery: PopulationQuery
  ) {}
  ngOnInit(): void {
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
    this.gamesGroup$ = this.gamesGroupService.fetchTriviaGroups();
    this.onTabChage(this.currentTab);
  }

  onTabChage(tab: GAME_TAB): void {
    this.currentTab = tab;
    const defaultSort: SortFn[] = [
      (a, b) => {
        const statusOrder = [
          ProgressStatus.InProgress,
          'Featured',
          ProgressStatus.NotStarted,
          'ComingSoon',
          ProgressStatus.Completed,
          'Locked',
        ];
        const getStatusIndex = (group: IGroupSummary) => {
          if (group.Locked) {
            return statusOrder.indexOf('Locked');
          }
          if (group.Status === ProgressStatus.NotStarted && group.ComingSoon) {
            return statusOrder.indexOf('ComingSoon');
          }
          if (group.Status === ProgressStatus.NotStarted && group.Featured) {
            return statusOrder.indexOf('Featured');
          }
          return statusOrder.indexOf(group.Status);
        };
        return getStatusIndex(a) - getStatusIndex(b);
      },
    ];
    if (tab === GAME_TAB.LIVE_UPCOMING) {
      this.filters = [filterBy({ EntityGroupCompleted: false }), filterBy({ Status: ProgressStatus.Completed }, '!=')];
      this.sort = [...defaultSort, sortBy('StartDate', 'asc', { type: 'date' })];
    } else if (tab === GAME_TAB.RESULTS) {
      this.filters = [
        filterBy({ EntityGroupCompleted: true }),
        { operator: 'or' },
        filterBy({ Status: ProgressStatus.Completed }),
      ];
      this.sort = [...defaultSort, sortBy('CompletionDate', 'desc', { type: 'date' })];
    }
  }
}
